<div class="navbar-header">
	@if (disableLink) {
		<span class="navbar-brand">
			<img class="logo d-none d-sm-block" height="40" width="140" [src]="logoUrl" />
			<img class="logo d-block d-sm-none" height="30" width="30" [src]="logoUrlSmall" />
		</span>
	} @else {
		<a [routerLink]="[redirectLink]" class="navbar-brand">
			<img class="logo d-none d-sm-block" height="40" width="140" [src]="logoUrl" />
			<img class="logo d-block d-sm-none" height="30" width="30" [src]="logoUrlSmall" />
		</a>
	}
</div>
